var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "WrapperHandleError",
    { attrs: { error: _vm.error, "is-error": _vm.isError } },
    [
      _c("SectionHeader", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h1", { staticClass: "header-1" }, [
                  _vm._v("Consulta de MDFE"),
                ]),
                _c(
                  "div",
                  { staticClass: "wrapper-buttons" },
                  [
                    _c("Popover", {
                      scopedSlots: _vm._u([
                        {
                          key: "trigger",
                          fn: function () {
                            return [
                              _c(
                                "o-button",
                                { attrs: { variant: "outline", size: "md" } },
                                [_vm._v(" Filtros ")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "content",
                          fn: function () {
                            return [
                              _c("FormFilter", {
                                attrs: {
                                  "query-params": _vm.queryParams,
                                  "handle-submit-filter":
                                    _vm.handleSubmitFilter,
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _c(
                      "o-button",
                      {
                        attrs: { variant: "primary", size: "md" },
                        on: { click: _vm.handleVisibility },
                      },
                      [_vm._v(" Emitir MDFE ")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "SkeletonTable",
        { attrs: { "is-loading": _vm.isLoadingTable } },
        [
          _c(
            "o-table",
            {
              staticClass: "space-m-y-32",
              attrs: {
                data: _vm.tableData,
                "row-key": "id",
                bordered: "",
                paginated: "",
                "backend-pagination": "",
                total: _vm.tableTotal,
                "per-page": _vm.queryParams.perPage,
                "current-page": _vm.queryParams.currentPage,
                "pagination-simple": false,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.queryParams, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.queryParams, "currentPage", $event)
                },
              },
            },
            [
              _c("o-table-column", {
                attrs: { field: "mdfeNumber", label: "Número" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [_vm._v(" " + _vm._s(props.row.mdfeNumber) + " ")]
                    },
                  },
                ]),
              }),
              _c("o-table-column", {
                attrs: { field: "mdfeKey", label: "Chave" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [_vm._v(" " + _vm._s(props.row.mdfeKey) + " ")]
                    },
                  },
                ]),
              }),
              _c("o-table-column", {
                attrs: { field: "receiptNumber", label: "Número da receita" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(" " + _vm._s(props.row.receiptNumber) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("o-table-column", {
                attrs: {
                  field: "protocolNumber",
                  label: "Número de Protocolo",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(" " + _vm._s(props.row.protocolNumber) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("o-table-column", {
                attrs: { field: "emissionDate", label: "Data de emissão" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm
                                .dayjs(props.row.emissionDate)
                                .format("DD/MM/YYYY, HH:mm:ss")
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("o-table-column", {
                attrs: { label: "", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("Actions", { attrs: { row: row } })]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "o-modal",
        {
          attrs: { active: _vm.isOpen, width: "660" },
          on: { close: _vm.handleVisibility },
        },
        [
          _c("div", [
            _c("h2", { staticClass: "header-2" }, [_vm._v("Gerando MDFE")]),
            _c("p", { staticClass: "paragraph" }, [
              _vm._v(
                "Preencha os campos logo abaixo para conseguir gerar um MDFE em nosso sistema"
              ),
            ]),
          ]),
          _c("FormCreateVtag", {
            attrs: { "close-modal": _vm.handleVisibility },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }